<template>
    <div class="page-container">
        <div class="item" @click="jumpPage('partner')">
            <span>合伙人政策</span>
            <van-icon name="arrow" size="18" color="#c8c8c8" />
        </div>
        <div class="item" @click="jumpPage('reward')">
            <span>推荐人奖励政策</span>
            <van-icon name="arrow" size="18" color="#c8c8c8" />
        </div>
        <!-- <div class="item" @click="jumpPage('xsjl')">
            <span>销售奖励政策</span>
            <van-icon name="arrow" size="18" color="#c8c8c8" />
        </div>
        <div class="item" @click="jumpPage('hzjt')">
            <span>战略合伙人津贴政策</span>
            <van-icon name="arrow" size="18" color="#c8c8c8" />
        </div> -->
    </div>
</template>
<script>
import { Icon } from 'vant'

export default {
    components:{
        [Icon.name]:Icon
    },
    methods:{
        jumpPage(type){
            this.$router.push({
                name:'reward-rules',
                query:{
                    role:type
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    background: #f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    padding:10px;
    .item{
        height:44px;
        background:#fff;
        border-radius: 4px;
        padding:0 15px;
        @include flex-between();
        margin-bottom: 10px;
        &>span{
            font-size: 14px;
            color:#333;
            line-height: 20px;
        }
    }
}
</style>